// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UploadErrorMessageArea_wrapper__BXckJ","icon":"UploadErrorMessageArea_icon__GrvI5","message-text":"UploadErrorMessageArea_message-text___Dkrb"};